export default ({
  name,
  code,
}) => ({
  name: name || '',
  code,
})
